import React, { useState } from 'react';
import images from '../../constants/images';
import { GiHamburgerMenu } from 'react-icons/gi';
import { MdOutlineRestaurantMenu } from 'react-icons/md';


const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  
  return (
  
    <nav className='app__navbar' id='navbar' >
      <div className='app__navbar-logo'>
        <img src={images.foodiverse} alt='app logo' />
      </div>
      <ul className='app__navbar-links'>
        <li className='p__opensans'><a href='#home'>Home</a></li>
        <li className='p__opensans'><a href='#about'>About Us</a></li>
        <li className='p__opensans'><a href='#menu'>Menu</a></li>
        <li className='p__opensans'><a href='#gallery'>Gallery</a></li>
        <li className='p__opensans'><a href='#contact'>Contact</a></li>
      </ul>
      <div className='app__navbar-login'>
        <a className='p__opensans' href='#login'>Log In / Register</a>
        <div />
        <a className='p__opensans' href='#booking'>Make Reservation</a>
      </div>

      {/* The div below is the navbar for mobile view, set to display 
      only on smallscreens */}

      <div className='app__navbar-smallscreen' >
        <GiHamburgerMenu className='menu_icon' 
        onClick={ () => {
          setToggleMenu(true);
        }} />
        { toggleMenu &&
          (<div className='app__navbar-smallscreen_overlay flex__center slide-bottom' >
            <MdOutlineRestaurantMenu className='menu_icon-overlay overlay__close' 
              onClick={ () => {
                setToggleMenu(false);
              }} />
            <ul className='app__navbar-smallscreen_links'>
              <li className='p__opensans'><a href='#home'>Home</a></li>
              <li className='p__opensans'><a href='#about'>About Us</a></li>
              <li className='p__opensans'><a href='#menu'>Menu</a></li>
              <li className='p__opensans'><a href='#gallery'>Gallery</a></li>
              <li className='p__opensans'><a href='#contact'>Contact</a></li>
            </ul>
            <div className='app__navbar-login_mobile'>
              <a className='p__opensans' href='#login'>Log In / Register</a>
              <a className='p__opensans' href='#booking'>Make Reservation</a>
            </div>
          </div>)
        }
      </div>
    </nav>
  )
};

export default Navbar;
